import React,{useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMenu,FiX,FiPhone}=FiIcons;

function Navigation() {
  const [menuOpen,setMenuOpen]=useState(false);
  const closeMenu=()=> setMenuOpen(false);
  return (
    <header className="site-header">
      <nav className="nav-wrap" aria-label="Main navigation">
        <a className="brand" href="#home" onClick={closeMenu}>RSS Driving School</a>
        <button className="menu-toggle" onClick={()=> setMenuOpen(!menuOpen)} aria-label={menuOpen ? 'Close menu' : 'Open menu'}>
          <SafeIcon icon={menuOpen ? FiX : FiMenu} />
        </button>
        <div className={`nav-links ${menuOpen ? 'is-open' : ''}`}>
          <a href="#about" onClick={closeMenu}>About</a>
          <a href="#lessons" onClick={closeMenu}>Lessons</a>
          <a href="#areas" onClick={closeMenu}>Areas</a>
          <a href="#pricing" onClick={closeMenu}>Pricing</a>
          <a href="#contact" onClick={closeMenu}>Contact</a>
          <a className="nav-cta" href="tel:0433037815" onClick={closeMenu}><SafeIcon icon={FiPhone} /> Call 0433 037 815</a>
        </div>
      </nav>
    </header>
  );
}

export default Navigation;